import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_LEGAL_CODE_INGRESO_REQUEST = "GET_LEGAL_CODE_INGRESO_REQUEST";
export const GET_LEGAL_CODE_INGRESO_SUCCESS = "GET_LEGAL_CODE_INGRESO_SUCCESS";
export const GET_LEGAL_CODE_INGRESO_ERROR = "GET_LEGAL_CODE_INGRESO_ERROR";

//* ACTIONS ------------------------------------------------
export const getCodeIngresoRequest = (payload = {}, callback) => ({
  type: GET_LEGAL_CODE_INGRESO_REQUEST,
  payload,
  callback,
});

export const getCodeIngresoSuccess = (data) => ({
  type: GET_LEGAL_CODE_INGRESO_SUCCESS,
  payload: data,
});

export const getCodeIngresoError = (error) => ({
  type: GET_LEGAL_CODE_INGRESO_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getCodeIngresoServiceRequest = async (params) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });
  return request(`/isr/report_f910_codes`, options);
};
